/**
 * Devuelve verdadero si la ruta del parámetro coincide con la ruta pre-renderizada en servidor (SSR).
 * @param path Ruta a comparar con la ruta prerenderizada, por defecto se compara la ruta actual.
 * @returns
 */
export default function useRouteHydrated(path?: string): Ref<boolean> {
  const hydratedRef = ref(false);
  const router = useRouter();
  const nuxtApp = useNuxtApp();
  const route1Ref = path
    ? ref(router.resolve({ path: path }))
    : router.currentRoute;
  const route2 = router.resolve({ path: nuxtApp.payload.path });
  watch(
    () => route1Ref.value.path,
    () => {
      const hydrated =
        import.meta.client &&
        nuxtApp.payload.serverRendered &&
        route1Ref.value.path === route2.path;
      hydratedRef.value = !!hydrated;
    },
    { immediate: true },
  );
  return hydratedRef;
}
